module.exports = __webpack_public_path__ + "img/telegram-black.b25ec2b.svg?v=1791296779994";